import { FC, MouseEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  title: {
    id: 'learning_session_learning_tools_coachmark_title',
    defaultMessage: 'Help me remember this',
  },
  description: {
    id: 'learning_session_learning_tools_coachmark_description',
    defaultMessage:
      "Learning Tools give you more ways to understand and remember what you're learning.",
  },
  close: {
    id: 'close',
  },
});

interface LearningToolsCoachmarkProps {
  onClose: () => void;
}

export const LearningToolsCoachmark: FC<LearningToolsCoachmarkProps> = ({ onClose }) => {
  const intl = useIntl();
  const stopPropagation = (event: MouseEvent) => event.stopPropagation();

  return (
    <>
      <S.Backdrop data-testid="learningToolsCoachmarkBackdrop" onClick={onClose} />
      <S.Card
        role="dialog"
        aria-modal="true"
        aria-labelledby="learning-tools-coachmark-title"
        aria-describedby="learning-tools-coachmark-description"
        data-testid="learningToolsCoachmark"
        onClick={stopPropagation}
      >
        <S.Arrow />
        <S.Title id="learning-tools-coachmark-title">{intl.formatMessage(msgs.title)}</S.Title>
        <S.CloseButton
          type="button"
          onClick={onClose}
          aria-label={intl.formatMessage(msgs.close)}
          data-testid="learningToolsCoachmarkClose"
        >
          <Icon name="close" />
        </S.CloseButton>
        <S.Description id="learning-tools-coachmark-description">
          {intl.formatMessage(msgs.description)}
        </S.Description>
      </S.Card>
    </>
  );
};
